import React, {
  useEffect,
} from 'react';

import Helmet from 'react-helmet';

import { stringify as stringifyQuery } from 'querystring';

import Page from 'hive-admin/src/components/Page';

import Admin from 'hive-admin';

import POSOutletContent from './POS';

import useQuery from '../modules/useQuery';

import posIconDefaultSrc from '../assets/pos-icon.png';

const RELOAD_EVERY_DEFAULT = 2 * 1000;
const HIDE_AFTER_DEFAULT = 60 * 1000;

function POSOutlet(props) {
  const { viewer: { storeData: store } } = props;
  const [{ loading, data }, reload] = useQuery(props.client, {
    url: `orders?${stringifyQuery({
      query: JSON.stringify({
        where: {
          store: store._id,
          showOnPosOutlet: true,
        },
        limit: 1,
        populate: {
          store: true,
          discountCode: true,
        },
      }),
    })}`,
  });
  const order = (
    (
      data
      && data.data
      && data.data.data
      && data.data.data.length
    )
    ? data.data.data[0]
    : null
  );
  const orderId = order ? order._id : null;
  useEffect(
    () => {
      let timeout = null;
      if (orderId) {
        timeout = setTimeout(
          () => {
            props.client.request({
              url: 'orders/posoutlet',
              method: 'post',
            });
          },
          Math.max(store?.posOutletClearAfter * 1000, 2) || HIDE_AFTER_DEFAULT,
        );
      }
      return () => {
        clearTimeout(timeout);
      };
    },
    [orderId, props.client, store.posOutletClearAfter],
  );
  useEffect(
    () => {
      const interval = setInterval(
        () => {
          reload();
        },
        Math.max(store?.posOutletCheckEvery * 1000, 2) || RELOAD_EVERY_DEFAULT
      );
      return () => {
        clearInterval(interval);
      };
    },
    [reload, store.posOutletCheckEvery],
  );
  return (
    <POSOutletContent
      store={store}
      order={order}
      loading={loading}
      outlet
    />
  );
}

export default class PagePOSOutlet extends Page {
  renderFound() {
    return (
      <>
        <Helmet>
          <title>POS Outlet</title>
          <link
            rel="apple-touch-icon"
            // href={this.props.viewer.storeData.posOutletIcon.src}
            href={
              this?.props?.viewer?.storeData?.posOutletAppIcon?.src
              || posIconDefaultSrc
            }
          />
        </Helmet>
        <POSOutlet
          client={this.props.client}
          viewer={this.props.viewer}
        />
      </>
    );
  }
}

Admin.addToLibrary('PagePOSOutlet', config => PagePOSOutlet.create(config));
